import React, { useEffect, useState } from 'react';
import { Card, Button } from '@shopify/polaris';
import { authenticatedFetch } from '../utils/api';
import { config } from '../constants';

// Helper: Get the theme editor app embed settings URL for this store
function getThemeEditorAppEmbedUrl(shop) {
  return `https://${shop}/admin/themes/current/editor?context=apps`;
}


export default function ThemeEmbedCard({ shop }) {
  const [isEmbedOn, setIsEmbedOn] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchEmbedStatus() {
      setLoading(true);
      try {
        const res = await authenticatedFetch(`${config.API_BASE}/embedding?shop=${shop}`);
        const data = await res.json();
        setIsEmbedOn(!!data.enabled);
      } catch {
        setIsEmbedOn(false);
      } finally {
        setLoading(false);
      }
    }
    if (shop) fetchEmbedStatus();
  }, [shop]);

  return (
    <Card sectioned>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 16 }}>App Integration</span>
          {loading ? (
            <span style={{ marginLeft: 4, fontSize: 14, color: '#999' }}>Loading...</span>
          ) : isEmbedOn ? (
            <span
              style={{
                background: '#affebf',
                color: '#108043',
                borderRadius: 12,
                fontWeight: 600,
                fontSize: 14,
                padding: '2px 12px',
                marginLeft: 4,
                display: 'inline-block',
                lineHeight: 1.5,
                letterSpacing: 0.2,
                verticalAlign: 'middle',
                border: 'none'
              }}
            >
              Enabled
            </span>
          ) : (
            <span
              style={{
                background: '#f4f6f8',
                color: '#6d7175',
                borderRadius: 12,
                fontWeight: 600,
                fontSize: 14,
                padding: '2px 12px',
                marginLeft: 4,
                display: 'inline-block',
                lineHeight: 1.5,
                letterSpacing: 0.2,
                verticalAlign: 'middle',
                border: 'none'
              }}
            >
              Disabled
            </span>
          )}
        </div>
        <Button
          onClick={() => {
            window.open(getThemeEditorAppEmbedUrl(shop), '_blank');
          }}
          primary
        >
          App Integration Settings
        </Button>
      </div>
    </Card>
  );
}
